import { useEffect, useRef } from "react";

/** Tells the launcher the first real screen is up, so it can reveal the iframe (VEX-8078). */
export function useRenderedSignal(rendered: boolean, parentOrigin: string | null) {
  const sentRef = useRef(false);

  useEffect(() => {
    if (!rendered || !parentOrigin || sentRef.current) return;
    sentRef.current = true;
    window.parent.postMessage({ source: "idme-verification", type: "IDME_RENDERED" }, parentOrigin);
  }, [rendered, parentOrigin]);
}
